const playerTrigger = <HTMLButtonElement>document.getElementById('fsight-yt-player-trigger');
const playerOverlay = <HTMLDivElement>document.querySelector('.fsight-yt-player__overlay');

/**
 * Creates a script tag for youtube api
 *
 * @returns void
 */
function getYoutubeApi() {
  const tag = <HTMLScriptElement>document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

/**
 * Starts the video when the player is ready
 *
 * @param  {Event} event
 * @returns void
 */
function onPlayerReady(event: Event) {
  // @ts-ignore - TS doesn't know about event.target
  event.target.playVideo();
}

/**
 * Create the youytube player based on the video id
 *
 * @returns {YTPlayer}
 */
function initialzieVideoPlayer(targetId: string) {
  // @ts-ignore - TS doesn't know about YT
  const player = new YT.Player('fSightYoutubePlayer', {
    height: '390',
    width: '640',
    videoId: targetId,
    playerVars: {
      playsinline: 1,
    },
    events: {
      onReady: onPlayerReady,
    },
  });

  return player;
}

/**
 * Removes the video player and creates an empty div
 *
 * @returns void
 */
function resetPlayer() {
  // Hide overlay
  playerOverlay.classList.remove('fsight-yt-player__overlay--active');

  // Delete video player
  document.getElementById('fSightYoutubePlayer').remove();

  // Re-add empty div
  playerOverlay.innerHTML = '<div id="fSightYoutubePlayer"></div>';
}

playerTrigger.addEventListener('click', (event: Event) => {
  // Prevent default behavior
  event.preventDefault();

  // Initialize the video
  initialzieVideoPlayer(playerTrigger.dataset.ytId);

  // Show overlay
  playerOverlay.classList.add('fsight-yt-player__overlay--active');
});

playerOverlay.addEventListener('click', resetPlayer);

document.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.keyCode === 27) resetPlayer();
});

// Get API script
getYoutubeApi();
